import React from "react"

const ConfirmationModal = ({
  show,
  onConfirm,
  onCancel,
  loading,
  message,
  loadingMessage,
}) => {
  if (!show) return null

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {loading ? (
          <div className="loading-container">
            <div>{loadingMessage}</div>
          </div>
        ) : (
          <>
            <div className="modal-header">
              <h3>{message}</h3>
            </div>
            <div className="modal-button-container">
              <button onClick={onConfirm} className="modal-button">
                Yes
              </button>
              <button onClick={onCancel} className="modal-button cancel">
                No
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default ConfirmationModal
